<script>
  import { Link, netPath } from '$client';
  import { page } from '$app/stores';
  export let pages = 1;
  export let span = 2;

  $: current = 1;
  $: pool = [];
  $: {
    const params = $page.url.searchParams;
    current = parseInt(params.get('page') ?? '1');
    if (current > pages || current < 1) current = 1;
    const possible = [];
    if (current !== pages && current !== 1) possible.push(current);
    for (let i = 1; i <= span / 2; i++) {
      const [left, right] = [current - i, current + i];
      if (left <= 1 && right >= pages) break;
      if (left > 1) possible.unshift(left);
      if (right < pages) possible.push(right);
    }
    pool = [1, ...possible];
    if (1 !== pages) pool.push(pages);
    if (pool.length > 1 && pool.at(-1) >= pool.at(-2) + 2) pool.push('...', pool.pop());
    if (pool.length > 1 && pool.at(0) <= pool.at(1) - 2) pool.unshift(pool.shift(), '...');
  }

  $: search = netPath($page.url.search.indexOf('?') === -1 ? '?' : $page.url.search);
  $: active = i => (i === current ? { class: 'active-route', disabled: true } : { class: 'color-button' });
  const replace = i => (_, prefix) => prefix + i;
  const fix = (url, i) => {
    if (i === 1 && url.includes('page=')) {
      const path = url.replace(/(page=)([0-9]+)/, '');
      return path.endsWith('?') ? path.slice(0, path.length - 1) : path;
    }

    if (url.includes('page=')) return url.replace(/(page=)([0-9]+)/, replace(i));
    return netPath(url)
      .joinQuery('page=' + i)
      .toString();
  };
</script>

<svelte:head>
  {#if current !== 1}
    <link rel="prev" href={fix($page.url.href, current - 1)} />
  {/if}
  {#if current !== pages}
    <link rel="next" href={fix($page.url.href, current + 1)} />
  {/if}
</svelte:head>

<nav class="pagination">
  <ol>
    <li>
      <Link
        attributes={{
          disabled: current === 1,
          class: 'pagination-left push-button',
          'aria-label': 'Вернуться на страницу назад',
        }}
        href={fix($page.url.href, current - 1)} />
    </li>
    {#each pool as link}
      {#if typeof link === 'string'}
        <li><Link attributes={{ disabled: true, class: 'more-pagination' }}>{link}</Link></li>
      {:else}
        <li><Link attributes={active(link)} href={fix($page.url.href, link)}>{link}</Link></li>
      {/if}
    {/each}
    <li>
      <Link
        attributes={{
          disabled: current === pages,
          class: 'pagination-right push-button',
          'aria-label': 'Перейти на следующую страницу',
        }}
        href={fix($page.url.href, current + 1)} />
    </li>
  </ol>
</nav>

<style lang="scss">
  ol {
    display: inline-flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 40px;

    :global(.pagination-left),
    :global(.pagination-right) {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;

      &::before {
        width: 100%;
        height: 100%;
        background: #2c333c;
        transform: scale(0.5);
        content: '';
        clip-path: polygon(50% 0, 60% 10%, 20% 50%, 60% 90%, 50% 100%, 0% 50%);
      }

      &:is(.pagination-left) {
        margin-right: -10px;
      }

      &:is(.pagination-right) {
        &::before {
          margin-left: -10px;
          transform: scale(0.5) rotate(180deg);
        }
      }
    }

    :global(a),
    :global(div) {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      color: #2c333c;
      font-weight: 600;
      font-size: 16px;
      font-family: Vela Sans;

      &:is([disabled='true']):not(.active-route, .more-pagination) {
        opacity: 0.25;
      }

      &:is(.active-route) {
        color: #fff;
        background: #2c333c;
        border-radius: 100px;
      }
    }
  }
</style>
